module.exports = __webpack_public_path__ + "assets/img/bg_block_02.4f9c1b7d.png";